import { createSelector } from 'reselect';
import { createSelectorDeep } from 'reselects/misc';

import { getShipperOrdersLoadStatus } from 'redux/modules/shipper-orders/selectors';

const statuses = ['PENDING_MODERATION'];

const _getFilters = (state) => ({
  ...state.queued.filters,
  ...state.common.filters,
});

const returnFilters = (filters, statuses) => ({
  ...filters,
  statuses,
});

export const getFilters = createSelectorDeep(_getFilters, () => statuses, returnFilters);

export const isQueuedReady = createSelector(
  getShipperOrdersLoadStatus,
  (progress) => progress.ready
);
